/**
 * Conta de mapa que não precisa de fornecedor (F265, F266).
 */
const EARTH_RADIUS_M = 6_371_008.8;
const radians = (degrees) => (degrees * Math.PI) / 180;
/** A distância em linha reta, em metros (haversine). */
export const straightMeters = (a, b) => {
    const dLat = radians(b.latitude - a.latitude);
    const dLng = radians(b.longitude - a.longitude);
    const h = Math.sin(dLat / 2) ** 2 +
        Math.cos(radians(a.latitude)) *
            Math.cos(radians(b.latitude)) *
            Math.sin(dLng / 2) ** 2;
    return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
};
/** O ponto está dentro do Brasil? A mesma caixa do check do banco (0144). */
export const isInBrazil = (point) => point.latitude >= -34 &&
    point.latitude <= 6 &&
    point.longitude >= -74 &&
    point.longitude <= -34;
/** Seis casas: o `numeric(9,6)` do banco, como texto. */
export const coordinateText = (value) => value.toFixed(6);
/**
 * A polyline codificada do Google (o "Encoded Polyline Algorithm Format",
 * precisão 5) de volta em pontos — para desenhar o caminho na tela.
 */
export const decodePolyline = (encoded) => {
    const points = [];
    let index = 0;
    let latitude = 0;
    let longitude = 0;
    const next = () => {
        let result = 0;
        let shift = 0;
        let byte;
        do {
            if (index >= encoded.length)
                return null;
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);
        return result & 1 ? ~(result >> 1) : result >> 1;
    };
    while (index < encoded.length) {
        const dLat = next();
        const dLng = next();
        if (dLat === null || dLng === null)
            break;
        latitude += dLat;
        longitude += dLng;
        points.push({ latitude: latitude / 1e5, longitude: longitude / 1e5 });
    }
    return points;
};
//# sourceMappingURL=geometry.js.map